import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { adminInovacaoAPI } from '../../services/inovacaoAPI';
import { mensagemErro } from './labels';
import { RefreshCw, Play, XCircle } from 'lucide-react';

export default function AdminInovacao() {
  const [aba, setAba] = useState('eventos');
  return (
    <div style={{ padding: 32 }}>
      <h1>Administração: Gestão de Projetos</h1>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16, borderBottom: '2px solid #eee' }}>
        {['eventos', 'jobs', 'falhados'].map((k) => (
          <button key={k} onClick={() => setAba(k)}
                  style={{ padding: '10px 16px', border: 'none', background: 'none',
                           borderBottom: aba === k ? '3px solid var(--brand, #20a490)' : '3px solid transparent',
                           color: aba === k ? 'var(--brand, #20a490)' : '#777', fontWeight: 600, cursor: 'pointer' }}>
            {k === 'eventos' ? 'Todos os eventos' : k === 'jobs' ? 'Jobs agendados' : 'Eventos falhados'}
          </button>
        ))}
      </div>
      {aba === 'eventos' && <TabelaEventos />}
      {aba === 'jobs' && <TabelaJobs />}
      {aba === 'falhados' && <TabelaEventos soFalhados />}
    </div>
  );
}

function TabelaEventos({ soFalhados = false }) {
  const [dados, setDados] = useState({ items: [], total: 0 });
  useEffect(() => {
    const params = { size: 50 };
    if (soFalhados) params.falhados = true;
    adminInovacaoAPI.listarEventos(params).then(setDados)
      .catch((e) => toast.error(mensagemErro(e, 'Erro ao carregar eventos')));
  }, [soFalhados]);

  async function reproc(id) {
    try { await adminInovacaoAPI.reprocessar(id); toast.success('Reprocessado'); const r = await adminInovacaoAPI.listarEventos({ size: 50, ...(soFalhados ? { falhados: true } : {}) }); setDados(r); }
    catch (e) { toast.error(e.response?.data?.detail?.message || 'Erro'); }
  }
  async function ignorar(id) {
    try { await adminInovacaoAPI.marcarIgnorado(id); toast.success('Ignorado'); const r = await adminInovacaoAPI.listarEventos({ size: 50, ...(soFalhados ? { falhados: true } : {}) }); setDados(r); }
    catch (e) { toast.error('Erro'); }
  }

  return (
    <>
      <p style={{ color: '#777' }}>Total: {dados.total}</p>
      <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse' }}>
        <thead style={{ background: '#f7f7f7' }}>
          <tr>
            <th style={{ padding: 8, textAlign: 'left' }}>ID</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Tipo</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Entidade</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Status</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Tentativas</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Ocorrido</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {dados.items.map((e) => (
            <tr key={e.id} style={{ borderTop: '1px solid #eee' }}>
              <td style={{ padding: 8 }}>{e.id}</td>
              <td style={{ padding: 8 }}><code>{e.tipo}</code></td>
              <td style={{ padding: 8 }}>{e.entidade}/{e.entidade_id}</td>
              <td style={{ padding: 8 }}>
                {e.processado_em
                  ? <span style={{ color: '#27ae60' }}>✓ processado</span>
                  : <span style={{ color: e.tentativas >= 5 ? '#e74c3c' : '#f39c12' }}>
                      {e.tentativas >= 5 ? 'DEAD-LETTER' : 'pendente'}
                    </span>}
              </td>
              <td style={{ padding: 8 }}>{e.tentativas}</td>
              <td style={{ padding: 8, fontSize: '0.8rem' }}>{new Date(e.ocorrido_em).toLocaleString('pt-BR')}</td>
              <td style={{ padding: 8 }}>
                {!e.processado_em && (
                  <>
                    <button onClick={() => reproc(e.id)}
                            style={{ padding: '4px 8px', background: '#3498db', color: '#fff',
                                     border: 'none', borderRadius: 4, marginRight: 4, cursor: 'pointer', fontSize: '0.8rem' }}>
                      <RefreshCw size={12} /> reprocessar
                    </button>
                    <button onClick={() => ignorar(e.id)}
                            style={{ padding: '4px 8px', background: '#95a5a6', color: '#fff',
                                     border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.8rem' }}>
                      <XCircle size={12} /> ignorar
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
          {dados.items.length === 0 && (
            <tr><td colSpan={7} style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>
              {soFalhados ? 'Nenhum evento falhado.' : 'Nenhum evento registrado.'}
            </td></tr>
          )}
        </tbody>
      </table>
    </>
  );
}

function TabelaJobs() {
  const [jobs, setJobs] = useState([]);
  async function carregar() { setJobs(await adminInovacaoAPI.listarJobs()); }
  useEffect(() => { carregar().catch((e) => toast.error(mensagemErro(e, 'Erro ao carregar jobs'))); }, []);
  async function executar(id) {
    try { const r = await adminInovacaoAPI.executarJob(id); toast.success(`Executado: ${JSON.stringify(r.resultado)}`); }
    catch (e) { toast.error(e.response?.data?.detail?.message || 'Erro'); }
  }
  return (
    <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse' }}>
      <thead style={{ background: '#f7f7f7' }}>
        <tr>
          <th style={{ padding: 12, textAlign: 'left' }}>ID</th>
          <th style={{ padding: 12, textAlign: 'left' }}>Trigger</th>
          <th style={{ padding: 12, textAlign: 'left' }}>Próxima execução</th>
          <th style={{ padding: 12, textAlign: 'left' }}>Ações</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map((j) => (
          <tr key={j.id} style={{ borderTop: '1px solid #eee' }}>
            <td style={{ padding: 12 }}><code>{j.id}</code></td>
            <td style={{ padding: 12, fontSize: '0.85rem' }}>{j.trigger}</td>
            <td style={{ padding: 12, fontSize: '0.85rem' }}>
              {j.next_run_time ? new Date(j.next_run_time).toLocaleString('pt-BR') : '—'}
            </td>
            <td style={{ padding: 12 }}>
              <button onClick={() => executar(j.id)}
                      style={{ padding: '6px 12px', background: '#3498db', color: '#fff',
                               border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.85rem' }}>
                <Play size={12} /> executar agora
              </button>
            </td>
          </tr>
        ))}
        {jobs.length === 0 && (
          <tr><td colSpan={4} style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>
            Nenhum job agendado.
          </td></tr>
        )}
      </tbody>
    </table>
  );
}
